// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"438d78b6","109":"7b661a37","113":"52a1e88c","161":"c77e83f8","776":"dd699849"}[chunkId] + ".chunk.js";
};